import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '../base/base.service';
import { BarChartDate } from '../../models';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseChartService<T> extends BaseService {
  protected constructor(baseRoute: string) {
    super(baseRoute);
  }

  get(model: BarChartDate): Observable<T[]> {
    return this.httpService.get<T[]>(
      `${this.apiUrl}?date=${model.date.toISOString()}&period=${model.period}&productId=${model.productId}&id=${
        model.id
      }`,
    );
  }
}
